"use client";

import { apiCheckVersion } from "@/api/home";
import { useAppVersionStore } from "@/store/app-version";
import { inApp, isGooglePlayApp } from "@/utils/interface";
import { get } from "@/utils/utils";
import { useCallback, useEffect } from "react";

export function useAppVersionCheck() {
    const {
        showVersionPopup,
        versionInfo,
        versionCheckFinished,
        setShowVersionPopup,
        setVersionInfo,
        setVersionCheckFinished,
    } = useAppVersionStore();

    useEffect( () => {
        if ( versionCheckFinished ) return; // 已检查过，不重复请求

        let cancelled = false;

        const checkVersion = async () => {
            if ( !inApp() || isGooglePlayApp() ) {
                setVersionCheckFinished( true );
                return;
            }

            const nativeChannel = window.AndroidShell?.getChannel?.();
            const channel = ( typeof nativeChannel === "string" && nativeChannel.trim() )
                ? nativeChannel.trim()
                : "h5";

            const [ isOk, res ] = await apiCheckVersion( { channelId: channel } );
            if ( cancelled ) return;

            if ( isOk ) {
                const info = get( res, "data", null );
                if ( info && info.levelUp && info.levelUp !== 2 ) {
                    setVersionInfo( info );
                    setShowVersionPopup( true );
                }
            }

            setVersionCheckFinished( true );
        };

        void checkVersion();
        return () => {
            cancelled = true;
        };
    }, [] );

    const handleVersionPopupOpenChange = useCallback( ( open: boolean ) => {
        setShowVersionPopup( open );
    }, [] );

    return { showVersionPopup, versionInfo, versionCheckFinished, handleVersionPopupOpenChange };
}
